import { render } from "./Dashboard.vue?vue&type=template&id=02f2037b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=02f2037b&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/projects/sms_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f2037b"]])

export default __exports__